import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from 'react-router-dom';
import {
    Badge,
    Button,
    Card,
    Form,
    Spinner,
    ListGroup,
    Alert,
    Modal
} from "react-bootstrap";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FaCheckCircle, FaCloudUploadAlt, FaFilePdf } from 'react-icons/fa';
import PdfSignerSelector from "../components/PdfSignerSelector/PdfSignerSelector";
import { useDropzone } from 'react-dropzone';
import "../../css/SignDocument.css";
import { ComponenteSpinner } from '../adminComponents/ComponenteSpinner';

export default function SignDocument() {

    //const accessToken = sessionStorage.getItem("access_token");
    const [accessToken, setAccessToken] = useState(
        sessionStorage.getItem("access_token") ||
        localStorage.getItem("access_token")
    );
    //const SignDocument = () => {

    // --- ESTADOS DE NEGOCIO ---
    const [signatures, setSignatures] = useState([]);
    const [selectedSignature, setSelectedSignature] = useState(null);
    const [password, setPassword] = useState('');
    const [nombrecompleto, setNombrecompleto] = useState('');
    const [pdfFile, setPdfFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const fileInputRef = useRef(null);
    // --- ESTADO PARA LOS DATOS DEL COMPONENTE ---
    const [signPayload, setSignPayload] = useState(null);
    const passwordRef = useRef(null); // Referencia para el scroll
    const [isPasswordHighlighted, setIsPasswordHighlighted] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [type, setType] = useState(null);
    // Nuevos estados
    const [showModal, setShowModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [fileName, setFileName] = useState("");
    const [isInitialized, setIsInitialized] = useState(false);

    /*useEffect(() => {
        let interval;
        alert("111111111111111111111111");
        console.log("signdocumenttest");
        const loadToken = () => {
            const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
            if (token) {
                setAccessToken(token);
                setIsInitialized(true);
                return true;
            }
            return false;
        };
        // Intento inmediato
        if (loadToken()) return;

        // Polling por si Flutter aún no lo inyecta
        let retries = 0;

        interval = setInterval(() => {
            const ok = loadToken();
            if (ok || retries > 20) {
                setIsInitialized(true);
                clearInterval(interval);
            }
            retries++;
        }, 300);

        // Listener Flutter
        const messageHandler = (event) => {
            if (event.data?.source === "miespol" && event.data?.accessToken) {
                sessionStorage.setItem("access_token", event.data.accessToken);
                setAccessToken(event.data.accessToken);
                setIsInitialized(true);
                clearInterval(interval);
            }
        };
        // Listener para evento personalizado (similar a RegistroFirmaIframe)
        const customTokenHandler = () => {
            loadToken();
        };

        window.addEventListener("message", messageHandler);
        window.addEventListener("entra-token-ready", customTokenHandler);
        return () => {
            clearInterval(interval);
            window.removeEventListener("message", messageHandler);
            window.removeEventListener("entra-token-ready", customTokenHandler);
        };
        
    }, []);*/

    useEffect(() => {

        const loadToken = () => {
            const token = sessionStorage.getItem("access_token");
            if (
                token &&
                token !== "undefined" &&
                token !== "null" &&
                token.split(".").length === 3
            ) {
                setAccessToken(token);
                setIsInitialized(true);
            }
        };

        // Si ya existe
        loadToken();

        // Esperar evento
        window.addEventListener(
            "entra-token-ready",
            loadToken,
            { once: true }
        );

        return () => {
            window.removeEventListener(
                "entra-token-ready",
                loadToken
            );
        };

    }, []);


    // 1. Cargar firmas (Lógica de ESPOL)
    useEffect(() => {
        //if (!accessToken) return;
        const isValidToken = (token) => {
            return token &&
                token !== "undefined" &&
                token !== "null" &&
                token.split(".").length === 3;
        };
        if (!isValidToken(accessToken)) {
            return;
        }
        const fetchSignatures = async () => {
            setLoading(true);
            try {

                const result = await fetch(`${process.env.REACT_APP_API_FIRMAS}/FirmaElectronica/ObtenerFirmasByPersona`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (!result.ok) throw new Error(`Error: ${result.status}`);
                const json = await result.json();
                const itemsActivos = json.listData.filter(item => item.estado === 'A').sort((a, b) => {
                    const fechaA = new Date(a.fechavencimiento);
                    const fechaB = new Date(b.fechavencimiento);
                    return fechaA - fechaB;
                });
                setSignatures(itemsActivos || []);
                if (itemsActivos.length > 0) {
                    setSelectedSignature(itemsActivos[0]);
                }
            } catch (err) {
                setError("Error al cargar firmas: " + err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchSignatures();
    }, [accessToken]);

    const handleToggle = () => {
        if (type === 'password') {
            setShowPassword(false);
            setType('text')
        } else {
            setShowPassword(true);
            setType('password')
        }
    }
    const handleOpenConfirmation = () => {
        if (signPayload) {
            setShowModal(true);
        }
    };
    const handleSelectionComplete = (data) => {
        if (data) {
            setSignPayload(data);
        }
    };
    // 2. Helper para Base64
    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = (error) => reject(error);
        });
    };
    const resetForm = () => {
        // 1. Limpiar estados de archivos y firmas
        setPdfFile(null);
        setSelectedSignature(null);
        setPassword('');
        setSignPayload(null);
        setError(null);
        setShowModal(false);
        setShowSuccessModal(false);
        if (signatures.length > 0) {
            setSelectedSignature(signatures[0]);
        } else {
            setSelectedSignature(null);
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };
    // 3. Ejecutar Firmado
    const handleSign = async () => {
        if (!pdfFile || !selectedSignature || !password.trim() || !signPayload) {
            return alert("Por favor, seleccione el archivo, la ubicación y complete los datos.");
        }

        setLoading(true);
        try {


            const pdfBase64 = await fileToBase64(pdfFile);

            const body = {
                idFirmaElectESPOL: selectedSignature.idfelfirmaelect,
                archivoPDF64: pdfBase64,
                password: password,
                modo: true,
                // DATOS QUE VIENEN DEL COMPONENTE ENCAPSULADO
                posicionX: signPayload.posicionX,
                posicionY: signPayload.posicionY,
                pagina: signPayload.pagina,
                signField: signPayload.signField
            };

            const response = await fetch(`${process.env.REACT_APP_API_FIRMAS}/FirmaElectronica/FirmarArchivo`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });

            const result = await response.json();
            if (!result.status.isSuccessfully) throw new Error(result.status.messages?.[0] || "Error al firmar");
            // if(result.data.archivoFirmado=="" || result.data.archivoFirmado==null) throw new Error(result.data.mensaje?.mensaje || "Error al firmar");
            if (!result.data.archivoFirmado) {
                const msgPrincipal = result.data.mensaje?.mensaje || "Error al firmar";
                const msgItem = result.data.mensaje?.item;

                // Si existe el item, lo concatenamos, si no, dejamos solo el principal
                const mensajeCompleto = msgItem
                    ? `${msgPrincipal}. ${msgItem}`
                    : msgPrincipal;

                throw new Error(mensajeCompleto);
            }
            // Lógica de descarga
            const byteCharacters = atob(result.data.archivoFirmado);
            const byteArray = new Uint8Array([...byteCharacters].map(c => c.charCodeAt(0)));
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${fileName}-firmado.pdf`;
            link.click();

            // alert(`¡Documento firmado con éxito en página ${signPayload.pagina}!`);
            setShowSuccessModal(true);
            setShowModal(false);
            // resetForm();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    //CONFIGURACION DE DRAG AND DROP
    const onDrop = useCallback(acceptedFiles => {
        const file = acceptedFiles[0];
        if (file) {
            setPdfFile(file);
            const nameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
            setFileName(nameWithoutExt);
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { 'application/pdf': ['.pdf'] },
        multiple: false,
        disabled: !signatures.length
    });

    useEffect(() => {
        window.onerror = function (message) {
            //alert("ERROR: " + message);
        };
    }, []);


    if (!isInitialized) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center p-5">
                <ComponenteSpinner />
                <p className="mt-3 text-muted">Cargando credenciales...</p>
            </div>
        );
    }
    return (
        <Card className="shadow p-4 mt-4">
            <h5 className="mb-4 text-center">Firmador Electrónico ESPOL</h5>
            <Form.Label className="fw-bold">Información de su Firma</Form.Label>
            {loading && !signatures.length ? (
                <div className="text-center"><Spinner animation="border" /></div>
            ) : (
                <ListGroup className="mb-3">
                    {signatures.map((firma) => (
                        <ListGroup.Item key={firma.idfelfirmaelect}>
                            <Form.Check
                                type="radio"
                                name="signature"
                                checked={selectedSignature?.idfelfirmaelect === firma.idfelfirmaelect}
                                label={`Su firma vence el ${new Date(firma.fechavencimiento).toLocaleDateString()}`}
                                onChange={() => setSelectedSignature(firma)}
                            />
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            )}
            {(!loading && !signatures.length) ? (
                <div>No cuenta con una firma Electrónica activa, proceda a crear una en
                    <Link to="/crearFirma" className="link-primary m-1">
                        Crear Firma
                    </Link>
                </div>
            ) : <div></div>}
            <Form.Group className="mb-4">
                {/* <Form.Label className="fw-bold">Seleccione el archivo PDF a firmar</Form.Label> */}
                <div
                    {...getRootProps()}
                    className={`dropzone-container ${isDragActive ? 'active' : ''} ${!signatures.length ? 'disabled' : ''}`}
                >
                    <input {...getInputProps()} />

                    <div className="dropzone-content">
                        {pdfFile ? (
                            <>
                                <FaFilePdf size={40} className="text-danger mb-2" />
                                <p className="mb-0 fw-bold">{pdfFile.name}</p>
                                <small className="text-muted">Haz clic o arrastra otro para cambiar</small>
                            </>
                        ) : (
                            <>
                                <FaCloudUploadAlt size={40} className="text-primary mb-2" />
                                <p className="mb-0">
                                    {isDragActive ? "¡Suelta el archivo aquí!" :
                                        (
                                            <>
                                                Seleccione el archivo PDF a firmar
                                                <br />
                                                <span className="text-muted small">Arrastra un PDF o haz clic para buscar</span>
                                            </>
                                        )}
                                </p>
                                <small className="text-muted">Solo archivos .pdf</small>
                            </>
                        )}
                    </div>
                </div>
                {/*<Form.Control type="file" accept=".pdf" ref={fileInputRef} 
                disabled={!signatures.length}
                onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                        setPdfFile(file);
                        // Extraemos el nombre y quitamos la extensión .pdf
                        const nameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
                        setFileName(nameWithoutExt);
                    }
                }} />*/}
            </Form.Group>

            {pdfFile && (
                <div className="mb-4">
                    <Form.Label className="fw-bold">Ubicación de la firma</Form.Label>
                    <PdfSignerSelector
                        pdfFile={pdfFile}
                        signFieldAlias="firma_qr"
                        boxConfig={{
                            backgroundColor: 'rgba(0, 123, 255, 0.2)',
                            userName: nombrecompleto,
                            borderColor: '#007bff',
                            text: 'CLIC AQUÍ',
                            stamp_height: 50,
                            stamp_width: 150
                        }}
                        onSelectionComplete={(data) => handleSelectionComplete(data)}
                        onConfirmLocation={handleOpenConfirmation}
                    />
                    {signPayload && (
                        <div className="text-center mt-2">
                            <Badge bg="success">Ubicación fijada en la página: {signPayload.pagina}</Badge>
                        </div>
                    )}
                </div>
            )}

            <hr />
            {/* MODAL DE CONFIRMACIÓN Y FIRMADO */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                onEntered={() => passwordRef.current?.focus()} // Auto focus al abrir
            >
                <Modal.Header closeButton={loading}>
                    <Modal.Title>Confirmar Firma Electrónica</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <label className="etiqueta-ayuda">
                        Si el estampado de la firma está en la ubicación correcta, proceda a firmar, caso contrario, cierre esta ventana para volver a ubicar la firma
                    </label>
                    <p></p>
                    <Form.Group className="mb-3">
                        <Form.Label className="etiqueta-form">Ingrese la contraseña de su firma</Form.Label>
                        <div className="input-group has-validation">
                            <Form.Control
                                ref={passwordRef}
                                type={showPassword ? "text" : "password"}
                                placeholder="Contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !loading && password) {
                                        e.preventDefault();
                                        handleSign();
                                    }
                                }}
                                isInvalid={!!error}
                                autoComplete="current-password"
                                className="form-control border-end-0"
                            />
                            <span className="input-group-text bg-white border-start-0 flex justify-around items-center cursor-pointer" onClick={handleToggle}>
                                {showPassword ? <FaEyeSlash className="absolute mr-10" size={18} /> : <FaEye size={18} />}
                            </span>
                            <Form.Control.Feedback type="invalid">
                                {error}
                            </Form.Control.Feedback>
                        </div>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary"
                        disabled={loading}
                        onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSign}
                        disabled={loading || !password}
                    >
                        {loading ? <Spinner animation="border" size="sm" /> : 'Firmar y Descargar'}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showSuccessModal}
                onHide={() => {
                    setShowSuccessModal(false);
                    resetForm();
                }}
                centered
            >
                <Modal.Body className="text-center p-5">
                    <FaCheckCircle size={60} color="#28a745" className="mb-3" />
                    <h3 className="fw-bold">¡Firmado Exitoso!</h3>
                    <p className="text-muted">
                        El documento ha sido firmado correctamente en la <strong>página {signPayload?.pagina}</strong> y la descarga ha comenzado automáticamente.
                    </p>
                    <Button
                        variant="primary"
                        className="mt-3 w-100"
                        onClick={() => {
                            setShowSuccessModal(false);
                            resetForm();
                        }}
                    >
                        Cerrar
                    </Button>
                </Modal.Body>
            </Modal>
            {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
        </Card>
    );
    //};
}